import { render } from "./content.vue?vue&type=template&id=5b046b95&scoped=true"
import script from "./content.vue?vue&type=script&lang=ts"
export * from "./content.vue?vue&type=script&lang=ts"

import "./content.vue?vue&type=style&index=0&id=5b046b95&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b046b95"

export default script